import React, { useMemo, useState } from "react";
import ReusableTable from "../../components/common/Table.tsx";
import { useLocation } from "react-router-dom";
import Button from "../../components/common/Button.tsx";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MRT_PaginationState } from "material-react-table";
import BreadCrumb from "../../components/common/BreadCrumb.tsx";

const BatchPredictionView = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const BatchData = location.state.BatchData.batch_results || [];
  const train_id = location.state.train_id;
  const predictor = location.state.predictor;

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const dynamicColumns = useMemo(() => {
    if (!BatchData || BatchData.length === 0) return [];

    const allKeys = Object.keys(BatchData[0]);

    return allKeys.map((key) => ({
      accessorKey: key,
      header: key
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      Cell: (info) => {
        const value = info?.renderedCellValue;
        if (typeof value === "number" || typeof value === "boolean") {
          return value.toLocaleString();
        }
        return value;
      },
    }));
  }, [BatchData]);

  const exportToCSV = () => {
    if (!BatchData || BatchData.length === 0) {
      alert("No data to export");
      return;
    }

    const headers = dynamicColumns.map((column) => column.header);

    const csvRows = BatchData.map((row) =>
      dynamicColumns.map((column) => JSON.stringify(row[column.accessorKey]))
    );

    const csvContent = [
      headers.join(","),
      ...csvRows.map((row) => row.join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", "batch_prediction_export.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <BreadCrumb moduleName={"Training"} pageName={"Batch Predictions Result"} viewName={location?.state?.predictor?.predictor_name} />
      <div className="d-flex flex-sm-row flex-column w-100 justify-content-between align-items-lg-center gap-2 mb-1 mt-0">
        <div className="d-flex flex-row gap-2">
          <h5 className="rv-page-title p-2">Batch Predictions</h5>
        </div>
        <div className="d-flex align-items-center">
          <button
            type="button"
            onClick={exportToCSV}
            className="btn-label rv-primary-btn me-2 rounded-1 px-4 py-1 text-nowrap btn btn-secondary"
          >
            <i className="ri-download-line label-icon align-middle fs-16 me-1"></i>
            <span className="ps-3 ms-2 me-1">Export File</span>
          </button>
        </div>
      </div>
      <div className="container-fluid px-0">
        <div className="disable-margin-card table-responsive table-customer border table-border w-100">
          <ReusableTable
            columns={dynamicColumns}
            data={BatchData}
            enablePagination={true}
            pagination={pagination}
            onPaginationChange={setPagination}
          />
        </div>
      </div>
      <div className="d-flex align-items-center">
        <button
          type="button"
          onClick={() => {
          navigate(`/batch-prediction/${train_id}`, 
            {state:
              {predictor: predictor}
            });
        }}
          className="btn-label rv-primary-btn me-2 rounded-1 px-4 py-1 text-nowrap btn btn-secondary"
        >
          <i className="ri-close-line label-icon align-middle fs-16 me-1"></i>
          <span className="ps-3 ms-2 me-1">Back</span>
        </button>
      </div>
    </>
  );
};

export default BatchPredictionView;
